export interface GameConfig {
  id: string;
  title: string;
  emoji: string;
  description: string;
  route: string;
  unlockLevel: number; // Level required to unlock (1-10)
  unlockXP: number; // XP required to unlock
}

// Game unlock requirements
export const GAME_CONFIGS: GameConfig[] = [
  {
    id: 'breakout',
    title: 'Breakout',
    emoji: '🎮',
    description: 'Break all the bricks with your paddle and ball!',
    route: '/games/breakout',
    unlockLevel: 1,
    unlockXP: 0, // Available from start
  },
  {
    id: 'helicopter',
    title: 'Helicopter',
    emoji: '🚁',
    description: 'Navigate through obstacles with your helicopter!',
    route: '/games/helicopter',
    unlockLevel: 3, // Unlocks at Level 3
    unlockXP: 300,
  },
  {
    id: '2048',
    title: '2048',
    emoji: '🔢',
    description: 'Combine tiles to reach 2048!',
    route: '/games/2048',
    unlockLevel: 5, // Unlocks at Level 5
    unlockXP: 1000,
  },
];

// Rank progression data (matches ProfilePage.tsx)
export const RANKS = [
  { level: 1, name: 'Budget Rookie', xp: 0 },
  { level: 2, name: 'Savings Scout', xp: 100 },
  { level: 3, name: 'Money Manager', xp: 300 },
  { level: 4, name: 'Finance Journeyman', xp: 500 },
  { level: 5, name: 'Dollar Defender', xp: 1000 },
  { level: 6, name: 'Wealth Warrior', xp: 1500 },
  { level: 7, name: 'Budget Baron', xp: 2000 },
  { level: 8, name: 'Finance Master', xp: 3000 },
  { level: 9, name: 'Money Mogul', xp: 4000 },
  { level: 10, name: 'Financial Legend', xp: 5000 },
];
